import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EDeleteAllNotificationActionTypes, TDeleteAllNotificationsFailed } from './types';

export const deleteAllFailed: () => TDeleteAllNotificationsFailed =
  actionGenerator<EDeleteAllNotificationActionTypes.Failed>(EDeleteAllNotificationActionTypes.Failed);
